import { useLayoutEffect } from "react";
import { useTheme } from "./ThemeProvider";
import { useSettingsStore } from "@/store/api/settingsStore";
import { useAppName } from "@/hooks/useAppName";
import { resolveAppBranding } from "@/config/appBranding";
import { resolveThemePolicy } from "@/lib/athleteTheme";

export function GymThemePolicySync() {
  const settings = useSettingsStore((state) => state.settings);
  const detectedAppName = useAppName();
  const { setForcedTheme } = useTheme();
  const appKey = resolveAppBranding(settings.appName ?? detectedAppName).key;
  const policy = resolveThemePolicy(settings.appearance.themePolicy, appKey === "VB20TN");

  useLayoutEffect(() => {
    setForcedTheme(policy === "user-choice" ? null : policy);
    return () => setForcedTheme(null);
  }, [policy, setForcedTheme]);

  return null;
}